// How the voice-over text is turned into what the TTS is actually given.
// Kept out of the generation panel so every screen that SHOWS what will be
// voiced shows the same thing the model will read.

// Line breaks inside one speaker's turn make the model insert huge pauses,
// so for the TTS payload they collapse into spaces. Two exceptions:
//  - a run of 3+ newlines is an intentional pause and is kept as-is;
//  - before a "Speaker N:" line they normalize to one blank line, the exact
//    turn separator AI Studio uses in its transcripts.
// The textarea keeps the original text — only the payload is transformed.
export const collapseNewlinesForTts = (src) => src.replace(/\n+/g, (run, offset, str) => {
  if (run.length >= 3) return run;
  const rest = str.slice(offset + run.length);
  if (/^\s*Speaker\s*\d+\s*:/.test(rest)) return '\n\n';
  return ' ';
});
